module.exports = __webpack_public_path__ + "static/media/Fill.6098d1a7.svg";